import React, { useEffect, useState } from "react";
import _ from "lodash";
import {
  createStyles,
  DialogActions,
  DialogContent,
  FormControlLabel,
  makeStyles,
  Typography,
} from "@material-ui/core";
import "jspdf-autotable";

import { CustomTheme } from "../../../../types/customTheme";
import TextfieldDefault from "../../../../components/textField/TextfieldDefault";
import DialogCommonDefault from "../../../../components/dialogs/DialogCommonDefault";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import SwitchCommon from "../../../../components/switches/SwitchCommon";

export interface DashboardCreateModalProps {
  open: any;
  setOpen: any;
  layout: any;
  setLayout: any;
  editableWidget: any;
  setSelectedWidgets: any;
  selectedWidgets: any;
}

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    autoComplete: {
      marginTop: "4px",
      "& .MuiAutocomplete-input": {
        color: theme.palette.custom.orange.contrastText,
      },
      "& .MuiInputBase-root": {
        color: "inherit",
        backgroundColor: theme.palette.background.entity_background,
        borderRadius: 10,
      },
      [`& fieldset`]: {
        borderRadius: 10,
        border: "none",
        color: theme.palette.custom.orange.contrastText,
      },
    },
  }),
);

const WidgetTitleSubtitleEditRemoveModal: React.FunctionComponent<
  DashboardCreateModalProps
> = ({
  open,
  setOpen,
  layout,
  setLayout,
  editableWidget,
  setSelectedWidgets,
  selectedWidgets,
}) => {
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [selectedAlign, setSelectedAlign] = useState("center");

  useEffect(() => {
    if (editableWidget && open) {
      setTitle(editableWidget?.title);
      setSubTitle(editableWidget?.subTitle);
      setSelectedAlign(editableWidget?.align ? editableWidget.align : "center");
    }
  }, [editableWidget, open]);
  const handleSave = () => {
    const cloneLayout = _.cloneDeep(layout);
    cloneLayout.forEach((data: any) => {
      if (data.i === editableWidget.key) {
        data["title"] = title;
        data.data["title"] = title;
        data["subTitle"] = subTitle;
        data.data["subTitle"] = subTitle;
        data.data["align"] = selectedAlign;
      }
    });
    const cloneSelectedWidgets = _.cloneDeep(selectedWidgets);

    cloneSelectedWidgets.map((data: any) => {
      if(data.key===editableWidget.key){
         data["title"] = title;
        data["subTitle"] = subTitle;
        data["align"] = selectedAlign;
      }
    })

    setSelectedWidgets(cloneSelectedWidgets);

    setLayout(cloneLayout);
    setOpen(false);
  };
  const handleTitleChange = (e: any) => {
    setTitle(e.target.value);
  };

  const handleSubTitleChange = (e: any) => {
    setSubTitle(e.target.value);
  };

  const handleActivate = (e: any) => {
    const name = e.target.name;
    setSelectedAlign((prev) => (prev === name ? "" : name));
  };

  return (
    <>
      <DialogCommonDefault
        open={open}
        setOpen={setOpen}
        maxWidth={"sm"}
        isNeedFixedHeight={false}
      >
        <DialogContent>
          {/* <Typography variant="h6" style={{ marginBottom: "12px" }}>
            {`Label for ${editableWidget?.labelInitial}`}
          </Typography> */}
          <Typography variant="body1" style={{ marginLeft: "4px" }}>
            Metric Title
          </Typography>
          {(editableWidget.label === "Title Box" ||
            editableWidget.label === "Heading" ||
            editableWidget.label === "Title Only Box" ||
            editableWidget.label === "Heading Only Box") && (
            <TextfieldDefault
              id=""
              name="Title"
              label={"Title"}
              type="text"
              value={title}
              onChange={handleTitleChange}
            />
          )}
          {(editableWidget.label === "Text Only Box" ||
            editableWidget.label === "Text Box" ||
            editableWidget.label === "Heading Only Box" ||
            editableWidget.label === "Heading") && (
            <TextfieldDefault
              id=""
              name="Sub Title"
              label={"Sub Title"}
              type="text"
              value={subTitle}
              onChange={handleSubTitleChange}
            />
          )}

          <Typography
            variant="body1"
            style={{ marginLeft: "4px", marginTop: "12px" }}
          >
            Text Alignment
          </Typography>
          <FormControlLabel
            style={{ marginRight: "0px" }}
            control={<SwitchCommon />}
            checked={selectedAlign === "left"}
            onChange={handleActivate}
            disabled={false}
            label="Left"
            labelPlacement="top"
            name="left"
          />

          <FormControlLabel
            style={{ marginRight: "0px" }}
            control={<SwitchCommon />}
            checked={selectedAlign === "center"}
            onChange={handleActivate}
            disabled={false}
            label="Centre"
            labelPlacement="top"
            name="center"
          />
          <FormControlLabel
            style={{ marginRight: "0px" }}
            control={<SwitchCommon />}
            checked={selectedAlign === "right"}
            onChange={handleActivate}
            disabled={false}
            label="Right"
            labelPlacement="top"
            name="right"
          />
        </DialogContent>
        <DialogActions style={{ marginBottom: "12px", marginRight: "12px" }}>
          <ButtonCommon
            style={{ width: "120px" }}
            onClick={() => setOpen(false)}
          >
            Cancel
          </ButtonCommon>
          <ButtonCommon
            style={{ width: "120px" }}
            onClick={handleSave}
            color="green"
          >
            Save
          </ButtonCommon>
        </DialogActions>
      </DialogCommonDefault>
    </>
  );
};

export default WidgetTitleSubtitleEditRemoveModal;
